import React, { ChangeEvent } from 'react';
import { ScoreValues } from './Interfaces';

interface Props {
    scores: ScoreValues;
    onScoreChange: (name: keyof ScoreValues, value: number | string) => void;
}

const ScoreInput: React.FC<Props> = ({ scores, onScoreChange }) => {
    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const name = event.target.name as keyof ScoreValues;
        const newScore = event.target.value ? parseFloat(event.target.value) : '';
        if (newScore === '' || (newScore >= 3 && newScore <= 9)) {
            onScoreChange(name, newScore);
        }
    };

    const getColorClass = (score: number | string) => {
        if (typeof score == 'string') {
            return ''
        }
        if (score >= 7) {
            return 'text-green-500'; // Green color for scores 7 and above
        } else if (score >= 5.5) {
            return 'text-yellow-500'; // Yellow color for scores between 5.5 and 6.5
        } else {
            return 'text-red-500'; // Red color for scores below 5.5
        }
    };

    return (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 bg-yellow-200 p-5">
            {(['listening', 'reading', 'writing', 'speaking'] as const).map((name) => (
                <div key={name} className="flex flex-col">
                    <label className="mb-2 text-2xl font-bold">{name.charAt(0).toUpperCase() + name.slice(1)}</label>
                    <select
                        name={name}
                        value={scores[name]}
                        onChange={handleChange}
                        className={`p-2 border border-gray-300 rounded w-auto font-bold text-xl ${getColorClass(scores[name])}`}
                    >
                        {Array.from({ length: 13 }, (_, i) => i * 0.5 + 3).map((score) => (
                            <option key={score} value={score}>
                                {score}
                            </option>
                        ))}
                    </select>
                </div>
            ))}
        </div>
    );
};

export default ScoreInput;
